import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import { Form } from 'antd';
import Widget from '../../Helpers/Widget';
const ClinicProvider = (props) => {
  const api = new API();
  const [clinicList, setClinicList] = useState([]);
  const [clinicTableFilter, setClinicTableFilter] = useState({
    name: '',
    _id: null,
    page: 1,
    limit: 10
  });
  const [clinicListLoader, setClinicListLoader] = useState(false);
  const [clinicAddPopup, setClinicAddPopup] = useState(false);
  const [clinicAddForm] = Form.useForm();
  const [clinicEditForm] = Form.useForm();
  const [addClinicLoader, setAddClinicLoader] = useState(false);
  const [editClinicLoader, setEditClinicLoader] = useState(false);
  const [clinicSingleData, setClinicSingleData] = useState({});
  const [clinicEditPopup, setClinicEditPopup] = useState(false);
  const [clinicSingleLoader, setClinicSingleLoader] = useState(false);
  const [clinicDeleteLoader, setClinicDeleteLoader] = useState(false);
  const [reviewList, setReviewList] = useState([]);
  const [reviewTableFilter, setReviewTableFilter] = useState({
    name: '',
    _id: null,
    page: 1,
    limit: 10
  });
  const [reviewListLoader, setReviewListLoader] = useState(false);

  const fetchClinicList = async () => {
    setClinicListLoader(true);
    localStorage.getItem("review_admin_login") === "true" &&
      (await api.getAll("clinic", { ...clinicTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setClinicList(res?.data?.data);
          setClinicListLoader(false);
        } else {
          setClinicList([]);
          setClinicListLoader(false);
        }
      }));
  };

  const fetchReviewList = async () => {
    setReviewListLoader(true);
    localStorage.getItem("review_admin_login") === "true" &&
      (await api.getAll("clinic/review", { ...reviewTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setReviewList(res?.data?.data);
          setReviewListLoader(false);
        } else {
          setReviewList([]);
          setReviewListLoader(false);
        }
      }));
  };

  const addClinic = async (data,reset=null) => {
    console.log("data",data)
    const form_data = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        form_data.append(key, value);
      }
    });
    form_data.append("status", 1);
    setAddClinicLoader(true);
    localStorage.getItem("review_admin_login") === "true" &&
      (await api.create("clinic/add", form_data, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          clinicAddForm.resetFields();
          fetchClinicList();
          reset && reset();
          setClinicAddPopup(false);
          setAddClinicLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setAddClinicLoader(false);
        }
      }));
  };

  const fetchSingleClinic = async (id) => {
    setClinicSingleLoader(true);
    localStorage.getItem("review_admin_login") === "true" &&
      (await api.getSingle("clinic/single", id, (err, res) => {
        if (res?.data?.status === 200) {
          setClinicSingleData(res?.data?.data);
          clinicEditForm.setFieldsValue({
            ...res?.data?.data,
            status: res?.data?.data?.status === 1 ? true : false
          });
          setClinicSingleLoader(false);
        } else {
          setClinicSingleData({});
          setClinicSingleLoader(false);
        }
      }));
  };

  const editClinic = async (data,reset=null) => {
    const form_data = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (key === "status") {
        form_data.append(key, value ? 1 : 0);
      } else if (value !== undefined && value !== null && value !== "") {
        form_data.append(key, value);
      }
    });

    setEditClinicLoader(true);
    localStorage.getItem("review_admin_login") === "true" &&
      (await api.update("clinic/edit", clinicSingleData._id, form_data, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          clinicEditForm.resetFields();
          reset && reset();
          fetchClinicList();
          setClinicEditPopup(false);
          setEditClinicLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setEditClinicLoader(false);
        }
      }));
  };

  const deleteClinic = async (id) => {
    setClinicDeleteLoader(true);
    localStorage.getItem("review_admin_login") === "true" &&
      (await api.remove("clinic/delete", id, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchClinicList();
          setClinicDeleteLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setClinicDeleteLoader(false);
        }
      }));
  };
 
  return (
    <Context.Provider value={{
      ...props,
      clinicList,
      setClinicList,
      clinicTableFilter,
      setClinicTableFilter,
      fetchClinicList,
      clinicListLoader,
      clinicAddPopup, setClinicAddPopup,
      clinicAddForm,
      addClinic,
      addClinicLoader, setAddClinicLoader,
      clinicEditForm,
      fetchSingleClinic,
      clinicEditPopup, setClinicEditPopup,
      clinicSingleData,
      clinicSingleLoader, setClinicSingleLoader,
      editClinicLoader, setEditClinicLoader,
      editClinic,
      deleteClinic,
      clinicDeleteLoader, setClinicDeleteLoader,
      reviewList, setReviewList,
      reviewTableFilter, setReviewTableFilter,
      reviewListLoader, setReviewListLoader,
      fetchReviewList,
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default ClinicProvider;
